import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import validators from 'services/validators';
import FormForm, {
  getFormInitValuesFromFieldsParams,
  simpleFormConstructor,
} from 'components/forms/Form';
import LayoutAuthForms from 'layout/AuthForms';
import { ContextMessages } from 'services/messages/context';
import { TRouteCompProps } from 'components/routes';
import useRouteDefParams from 'utils/useRouteDefParams';
import config from 'configShared';
import queryString from 'query-string';
import Link from 'components/ui/Link';
import IntlMessageFormat from 'intl-messageformat';
import { TAppState } from 'appTypes/common';
import * as actions from 'store/actions';

const ConfirmResetPassword: React.FC<TRouteCompProps> = ({ title }) => {
  useRouteDefParams({ title });
  const location = useLocation();
  const dispatch = useDispatch();
  const messages = React.useContext(ContextMessages);
  const { code } = queryString.parse(location.search);
  const { isProcessing } = useSelector((state: TAppState) => state.auth);
  const history = useHistory();

  if (!code) {
    return <Redirect to={config.defPublicRoute} />;
  }

  const params = simpleFormConstructor({
    messages,
    fields: ['password', 'passwordMatch'],
  });

  const msgSuccess = new IntlMessageFormat(
    messages.containers.auth.confirmResetPassword.attemptSuccess,
  );
  const msgFail = new IntlMessageFormat(
    messages.containers.auth.confirmResetPassword.attemptFail,
  );

  return (
    <LayoutAuthForms pageTitle={title} className="page_confirmResetPassword">
      <FormForm
        isProcessing={isProcessing}
        onSubmit={async (values, helpers) => {
          dispatch(
            actions.authOnConfirmResetPassword({
              data: {
                new_password: values.password,
                code,
              },
              own: {
                onFinish: () =>
                  dispatch(
                    actions.toastMessageAddSuccessRedirect(
                      {
                        msg: msgSuccess.format(),
                      },
                      config.routes.auth.signIn,
                      history,
                    ),
                  ),
                onFail: (error: any) =>
                  dispatch(
                    actions.toastMessageAddFail({
                      msg: msgFail.format(),
                      ...error,
                    }),
                  ),
              },
            }),
          );
        }}
        validationSchema={validators(messages).auth.confirmResetPassword}
        initialValues={getFormInitValuesFromFieldsParams(params)}
        params={params}
      />
      <Link href={config.routes.auth.signIn} className="textUnderTheAuthForm">
        Back to sign in
      </Link>
    </LayoutAuthForms>
  );
};

export default ConfirmResetPassword;
